/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-magic-numbers

import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestInfo } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';

export interface MockDataEndpoint {
  supportsUrl(url: string): boolean;

  supportsMethod(method: string): boolean;

  process(request: RequestInfo): Observable<HttpResponse<any>> | HttpResponse<any>;
}

export interface MockDataRegistry {
  getEndpoint(url: string, method: string): Maybe<MockDataEndpoint>;
}

export const mockSuccessResponse = (url: string,
                                    headers: Maybe<HttpHeaders>,
                                    body: any) => new HttpResponse({
  url,
  status: 200,
  statusText: 'OK',
  headers,
  body,
});
export const mockErrorResponse = (url: string,
                                  status: number,
                                  statusText: string,
                                  body: any = void 0) => new HttpResponse({ url, status, statusText, body });
export const mockBadRequestResponse = (url: string) => mockErrorResponse(url, 400, 'Bad Request');
export const mockNotFoundResponse = (url: string) => mockErrorResponse(url, 404, 'Not Found');
export const mockMethodNotAllowedResponse = (url: string) => mockErrorResponse(url, 405, 'Method Not Allowed');

export const decorateEndpoint = (endpoint: MockDataEndpoint,
                                 // tslint:disable-next-line:max-line-length
                                 processor: TransformFn<RequestInfo, Observable<HttpResponse<any>> | HttpResponse<any>>): MockDataEndpoint => ({
  supportsUrl: (url) => endpoint.supportsUrl(url),
  supportsMethod: (method) => endpoint.supportsMethod(method),
  process: processor,
});
